import graphql__e63643e39466b0f4571a from "./__generated__/InformativeMap_map.graphql.js";import { graphql, useFragment } from "react-relay";

import MapWithSidebarLayout from "./MapWithSidebarLayout";
import MapSidebar from "./MapSidebar";
import MapContextProvider from "./MapContext";
import MapFilters from "./MapFilters";
import MapEventMarkersManager from "./MapEvent/MapEventMarkersManager";

const InformativeMap = props => {
  const map = useFragment(InformativeMap_map, props.map);
  const { sidebar } = map;

  return (
    <MapContextProvider map={map}>
      <MapWithSidebarLayout map={map}>
        <MapSidebar map={map} sidebar={sidebar}>
          <MapFilters map={map} />
        </MapSidebar>

        <MapEventMarkersManager mapId={map.id} />
      </MapWithSidebarLayout>
    </MapContextProvider>
  );
};

const InformativeMap_map = graphql__e63643e39466b0f4571a;

export default InformativeMap;
